import { HandoverLineMode } from '../forms/handover/HandoverLineMode';

export const lineToHandoverLineMode = <T extends { isIncludeOnHandoverCertificate: boolean; isRefundable: boolean }>(line: T): HandoverLineMode => {
	return line.isIncludeOnHandoverCertificate === false ? 'exclude' : line.isRefundable ? 'refundable' : 'nonRefundable';
};
